let user_id_el = document.querySelector('meta[name="_id"]');
let header_messenger_el = document.querySelector("#messenger-menu");
var notification_menu_trigger = document.querySelector(
    "#notification-menu-trigger"
);

var notification_menu_dropdown = document.querySelector(
    "#notification-menu-dropdown"
);

if (user_id_el) {
    var user_id = user_id_el.getAttribute("content");

    var new_message_sound = document.createElement("AUDIO");
    document.body.appendChild(new_message_sound);
    new_message_sound.src = "/assets/sounds/new_notification.mp3";

    var notification_badge = document.querySelector("#notification-badge");

    window.Echo.private("App.Models.User." + user_id)
        .notification((notification) => {
            //console.log(notification);
            try {
                new_message_sound.currentTime = 0;
                new_message_sound.play();
            } catch (error) {}
            document.querySelector("#no-notification").classList.add("d-none");
            window.unread_notifications = window.unread_notifications + 1;
            window.updatetitleNotifier();
            notification_badge.innerHTML = window.unread_notifications;

            if (window.unread_notifications > 0)
                notification_badge.classList.remove("d-none");
            else notification_badge.classList.add("d-none");

            document.querySelector("#notification-lists").innerHTML =
                notification.html +
                document.querySelector("#notification-lists").innerHTML;
        })
        .listen(".notificationSeen", (e) => {
            notification_badge.classList.add("d-none");
            notification_badge.innerHTML = "0";
            window.unread_notifications = 0;
            window.updatetitleNotifier();
        })
        .listen(".messengerNotification", (e) => {
            var tmp_count_el = header_messenger_el.querySelector(".count");
            if (tmp_count_el) tmp_count_el.remove();
            if (e.unread_count > 0) {
                if (typeof messenger_page === "undefined") {
                    try {
                        new_message_sound.currentTime = 0;
                        new_message_sound.play();
                    } catch (error) {}
                }
                var tmp_menu_icon_el = header_messenger_el.querySelector(
                    ".messenger-menu-icon"
                );
                if (tmp_menu_icon_el)
                    tmp_menu_icon_el.insertAdjacentHTML(
                        "beforeend",
                        '<div class="count">' + e.unread_count + "</div>"
                    );
            }
            window.messenger_unread_messages = e.unread_count;
            window.updatetitleNotifier();
        })
        .listen(".userLogout", (e) => {
            axios.post("/checkAuth").then(
                (response) => {},
                (error) => {
                    location.reload();
                }
            );
        });

    if (notification_menu_trigger) {
        notification_menu_trigger.addEventListener("click", (e) => {
            e.preventDefault();
            if (!notification_menu_dropdown.classList.contains("show")) {
                document
                    .querySelector("#notification-badge")
                    .classList.add("d-none");
                window.unread_notifications = 0;
                window.updatetitleNotifier();
                axios.put("/notifications/markAllAsRead").then(
                    (response) => {},
                    (error) => {
                        //console.log(error);
                    }
                );
            }
        });
    }
}
